import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./ReadMore.scss";

const propTypes = {
  children: PropTypes.node.isRequired,
  labels: PropTypes.shape({
    hidden: PropTypes.string.isRequired,
    visible: PropTypes.string.isRequired,
  }),
};

const ReadMore = ({ children, labels }) => {
  const [hidden, setHidden] = React.useState(true);

  const handleToggle = () => {
    setHidden(!hidden);
  };

  const childrenArray = React.Children.toArray(children);
  const label = hidden ? labels.hidden : labels.visible;

  return (
    <div className="ReadMore">
      <div
        className={classnames("ReadMore-items", {
          "is-hidden": hidden,
        })}
        data-testid="ReadMore-items"
      >
        {childrenArray}
      </div>
      <button
        className="ReadMore-toggle"
        data-testid="ReadMore-toggle"
        onClick={handleToggle}
      >
        {label}
      </button>
    </div>
  );
};

ReadMore.propTypes = propTypes;
export default ReadMore;
